import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'

const SignUpErrorDialog = () => {
  const dispatch = useDispatch()
  const signUpFlowPopup = useSelector(state => state.signup.signUpFlowPopup)
  const antidoteSupportPhone = useSelector(
    state => state.app.antidoteSupportPhone
  )

  const closeDialog = () => {
    dispatch(Actions.createAction(Actions.CLOSE_SIGNUP_ERROR_POPUP))
  }

  const actions = [
    <Button
      key="2"
      className="dialog-action"
      type="primary"
      onClick={closeDialog}
    >
      {$t('common.ok')}
    </Button>,
  ]

  return (
    <>
      <Dialog
        title={$t('somethingWentWrongDialog.title')}
        isVisible={!!signUpFlowPopup}
        footerActions={actions}
        onCancel={closeDialog}
        className="declare-location-dialog"
      >
        <div className="dialog-content">
          <div className="subtitle">
            {$t('errors.' + signUpFlowPopup, { phone: antidoteSupportPhone })}
          </div>
        </div>
      </Dialog>
    </>
  )
}

export default SignUpErrorDialog
